import { render, staticRenderFns } from "./AddInformation.vue?vue&type=template&id=4610a150&scoped=true&"
import script from "./AddInformation.vue?vue&type=script&lang=js&"
export * from "./AddInformation.vue?vue&type=script&lang=js&"
import style0 from "./AddInformation.vue?vue&type=style&index=0&id=4610a150&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4610a150",
  null
  
)

export default component.exports